/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { DeviceEquipmentFamilyInformation } from '../../components/add-family-information/device-equipment-family-information/device-equipment-family-information.component';
import { SysquePopupConfig } from '../../models/sysque-popup-config';
import { PopupDialog } from '../popup-dialog.interface';

export class DeviceEquipmentFamilyInformationDialog implements PopupDialog {
  create(sysquePopupConfig: SysquePopupConfig): any {
    sysquePopupConfig.component = DeviceEquipmentFamilyInformation;
    sysquePopupConfig.width = 1080;
    sysquePopupConfig.height = 650;
    sysquePopupConfig.componentTitle = '';
    sysquePopupConfig.visible = true;
  }
}